// Lucide icon: thumbs-up (https://lucide.dev/icons/thumbs-up)
import { ThumbsUp } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconThumbsUp = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ThumbsUp />
    </IconComponentStyled>
  )
}
